import React from "react";

const Loader = ({ dark }) => {
  const bg   = dark ? "#070B14" : "#F8FAFF";
  const card = dark ? "#0F1629" : "#FFFFFF";
  const mut  = dark ? "#475569" : "#94A3B8";

  return (
    <div style={{
      height: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      background: bg, overflow: "hidden", position: "relative",
    }}>

      <style>{`
        /* grid bg */
        .dgh-loader-grid {
          position: absolute; inset: 0; pointer-events: none;
          background-image:
            linear-gradient(${dark?"rgba(255,255,255,.04)":"rgba(0,0,0,.04)"} 1px, transparent 1px),
            linear-gradient(90deg, ${dark?"rgba(255,255,255,.04)":"rgba(0,0,0,.04)"} 1px, transparent 1px);
          background-size: 48px 48px;
        }
        /* ambient glows */
        .dgh-glow-a {
          position: absolute; width: 340px; height: 340px; border-radius: 50%;
          background: radial-gradient(circle, rgba(245,158,11,.18) 0%, transparent 70%);
          top: -80px; right: -80px; pointer-events: none;
        }
        .dgh-glow-b {
          position: absolute; width: 260px; height: 260px; border-radius: 50%;
          background: radial-gradient(circle, rgba(249,115,22,.12) 0%, transparent 70%);
          bottom: -60px; left: -60px; pointer-events: none;
        }

        /* logo card */
        @keyframes dgh-pop {
          0%   { opacity:0; transform: scale(.7) translateY(20px); }
          60%  { opacity:1; transform: scale(1.06) translateY(-4px); }
          100% { transform: scale(1) translateY(0); }
        }
        .dgh-card {
          animation: dgh-pop .55s cubic-bezier(.34,1.56,.64,1) forwards;
        }

        /* shimmer text */
        @keyframes dgh-shimmer {
          0%   { background-position: -200% center; }
          100% { background-position:  200% center; }
        }
        .dgh-brand {
          background: linear-gradient(90deg, #F59E0B 0%, #F97316 30%, #FCD34D 50%, #F97316 70%, #F59E0B 100%);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: dgh-shimmer 2.2s linear infinite;
        }

        /* progress bar */
        @keyframes dgh-progress {
          0%   { width: 0%; opacity: 1; }
          80%  { width: 90%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
        .dgh-bar {
          animation: dgh-progress 2s ease-out infinite;
        }

        /* dots */
        @keyframes dgh-dot {
          0%,80%,100% { transform: scale(.6); opacity: .3; }
          40%          { transform: scale(1);   opacity: 1; }
        }
        .dgh-dot-1 { animation: dgh-dot 1.2s ease-in-out .0s infinite; }
        .dgh-dot-2 { animation: dgh-dot 1.2s ease-in-out .2s infinite; }
        .dgh-dot-3 { animation: dgh-dot 1.2s ease-in-out .4s infinite; }

        /* fade-in text */
        @keyframes dgh-fadein {
          from { opacity:0; transform: translateY(10px); }
          to   { opacity:1; transform: translateY(0); }
        }
        .dgh-tagline {
          animation: dgh-fadein .6s .5s ease both;
        }
      `}</style>

      {/* bg decoration */}
      <div className="dgh-loader-grid"/>
      <div className="dgh-glow-a"/>
      <div className="dgh-glow-b"/>

      {/* main card */}
      <div className="dgh-card" style={{
        background: card,
        border: `1px solid ${dark?"rgba(245,158,11,.15)":"rgba(245,158,11,.2)"}`,
        borderRadius: 24,
        padding: "36px 48px",
        display: "flex", flexDirection: "column", alignItems: "center",
        gap: 18, position: "relative", zIndex: 2,
        boxShadow: dark
          ? "0 24px 80px rgba(0,0,0,.6), 0 0 0 1px rgba(245,158,11,.08)"
          : "0 24px 80px rgba(0,0,0,.12)",
        minWidth: 260,
      }}>

        {/* Logo + Name row */}
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <div style={{
            width:52, height:52, borderRadius:14, overflow:"hidden",
            background:"linear-gradient(135deg,#F59E0B,#F97316)",
            display:"flex", alignItems:"center", justifyContent:"center",
            flexShrink:0,
          }}>
            <img src="/images/logo.png" alt="DG HelpMate"
              style={{ width:"100%", height:"100%", objectFit:"contain" }}
              onError={e=>{
                e.target.style.display="none";
                e.target.parentElement.innerHTML=`<span style="font-weight:900;font-size:20px;color:#070B14;">DG</span>`;
              }}
            />
          </div>
          <div>
            <div style={{ fontSize:"1.25rem", fontWeight:900, letterSpacing:"-.01em" }}>
              <span className="dgh-brand">DG HelpMate</span>
            </div>
            <div style={{ fontSize:".72rem", color:mut, letterSpacing:".08em", textTransform:"uppercase", marginTop:2 }}>
              Digital Support Platform
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ width:"100%", height:1, background: dark?"rgba(255,255,255,.06)":"rgba(0,0,0,.06)" }}/>

        {/* Progress bar */}
        <div style={{ width:"100%", height:3, background: dark?"rgba(255,255,255,.06)":"rgba(0,0,0,.06)", borderRadius:99, overflow:"hidden" }}>
          <div className="dgh-bar" style={{
            height:"100%",
            background:"linear-gradient(90deg,#F59E0B,#F97316,#F59E0B)",
            borderRadius:99,
          }}/>
        </div>

        {/* Dots + label */}
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:10 }}>
          <div style={{ display:"flex", gap:7 }}>
            {["dgh-dot-1","dgh-dot-2","dgh-dot-3"].map(cls=>(
              <div key={cls} className={cls} style={{
                width:8, height:8, borderRadius:"50%",
                background:"linear-gradient(135deg,#F59E0B,#F97316)",
              }}/>
            ))}
          </div>
          <div className="dgh-tagline" style={{ fontSize:".78rem", color:mut, letterSpacing:".06em" }}>
            Loading, please wait…
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
